import { observer } from 'mobx-react';

import { useSideMenu } from '../../hooks/useSideMenu';
import { NotificationDot } from '../Notifications/NotificationDot';
import { Hamburger } from '../SVGIcons/Hamburger';

import classes from './Headers.module.scss';

export const MenuToggle = observer(function MenuToggle() {
  const { handleToggle } = useSideMenu();

  return (
    <button className={classes.hamburger} data-testid="menuButton" onClick={handleToggle}>
      <Hamburger />
      <div className={classes.dot_wrapper}>
        <NotificationDot type="small" />
      </div>
    </button>
  );
});
